<span mat-dialog-title>{{ 'ORDERS.CANCELLATION_DIALOG.TITLE' | translate }}</span>
<div mat-dialog-actions>
  <button mat-flat-button mat-dialog-close="true" color="warn">{{ 'ORDERS.DASHBOARD.CANCEL' | translate }}</button>
  <button mat-flat-button mat-dialog-close="false" color="primary">{{ 'GENERAL.CANCEL' | translate }}</button>
</div>
